import React from 'react';
import { Popover } from 'antd';
import { FileImageOutlined } from '@ant-design/icons';
import { RADIUS } from '../../constants/constants';
import { useThemeTokens } from '../../hooks/UseThemeTokens';

interface Props {
  imageUrl: string | null;
  alt?:     string;
  /** 썸네일 가로 px(세로는 카드 비율 1.4배). 기본 36. */
  size?:    number;
  /** hover 시 Popover로 확대해 보여줄지. 기본 true. 이미 큰 썸네일(검색 결과 목록 등)에서는
   *  false로 꺼서 굳이 한 번 더 확대 안 되게 한다. */
  preview?: boolean;
}

/**
 * 카드 썸네일. 마우스를 올리면 Popover 로 큰 이미지를 보여 준다(hover 확대).
 * 이미지가 없으면(수기 카드 등) 플레이스홀더 아이콘을 보여 준다.
 */
export const CardThumb: React.FC<Props> = ({ imageUrl, alt, size = 36, preview = true }) => {
  const t = useThemeTokens();

  const box: React.CSSProperties = {
    width: size,
    height: Math.round(size * 1.4),
    borderRadius: RADIUS.sm,
    border: `1px solid ${t.border}`,
    background: t.bgRaised,
    objectFit: 'cover',
    flex: '0 0 auto',
    display: 'block',
  };

  if (!imageUrl) {
    return (
      <div style={{ ...box, display: 'flex', alignItems: 'center', justifyContent: 'center', color: t.textMuted }}>
        <FileImageOutlined />
      </div>
    );
  }

  if (!preview) {
    return <img src={imageUrl} alt={alt ?? ''} style={box} loading="lazy" />;
  }

  const large = (
    <img
      src={imageUrl}
      alt={alt ?? ''}
      style={{ width: 240, maxHeight: 340, objectFit: 'contain', borderRadius: RADIUS.md, display: 'block' }}
    />
  );

  return (
    <Popover content={large} trigger="hover" placement="right" mouseEnterDelay={0.1}>
      <img src={imageUrl} alt={alt ?? ''} style={{ ...box, cursor: 'zoom-in' }} loading="lazy" />
    </Popover>
  );
};
